import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import DeviceMappingMenuContent from './DeviceMappingMenuContent';

function SideMenuMobile({ open, toggleDrawer, user, onLogout }) {
  const displayName = user?.first_name || user?.username || 'User';
  const email = user?.email || '';

  const handleLogout = () => {
    toggleDrawer(false)();
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          minWidth: '280px',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 1, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1.5, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={displayName}
              src="/static/images/avatar/7.jpg"
              sx={{ width: 32, height: 32 }}
            />
            <Stack sx={{ minWidth: 0 }}>
              <Typography
                component="p"
                variant="body1"
                sx={{ fontWeight: 500, lineHeight: '16px' }}
              >
                {displayName}
              </Typography>
              {email && (
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.secondary',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {email}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1, overflow: 'auto' }}>
          <DeviceMappingMenuContent onNavigate={toggleDrawer(false)} />
        </Stack>
        <Divider />
        <Stack sx={{ p: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  user: PropTypes.object,
  onLogout: PropTypes.func,
};

export default SideMenuMobile;
